import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MUITooltip from '@material-ui/core/Tooltip';

import { useHideEditControls } from 'common/disabled-context';
import { ElemType, MapClassesToElem } from '../../helpers/styles-helpers';
import removeLocked from '../../assets/svg/remove-locked.svg';
import useStyles from './remove-locked-button.styles';

function RemoveLockedButton({ mode, text }) {
  const classes = useStyles();
  if (useHideEditControls()) {
    return null;
  }
  return (
    <MUITooltip interactive arrow placement="top" title={text} classes={{ tooltip: classes.tooltip }}>
      <IconButton
        classes={
          mode
            ? MapClassesToElem(`${mode}-${ElemType.IconButton}`, classes)
            : MapClassesToElem(ElemType.IconButton, classes)
        }
      >
        <img src={removeLocked} alt="remove-disabled" />
      </IconButton>
    </MUITooltip>
  );
}

RemoveLockedButton.propTypes = {
  mode: PropTypes.oneOf([null, 'big']),
  text: PropTypes.string.isRequired
};

RemoveLockedButton.defaultProps = {
  mode: 'big'
};

export default RemoveLockedButton;
